import { AccountCustomerTypeEnum, type AccountItemType } from 'app/types/user';
import { printf } from 'app/utils/i18n';

/**
 * 获取定时入金账户的展示标签，区分个人账户和 IRA 账户，并细分 IRA 账户的类型
 */
export const getAccountLabel = (account: AccountItemType) => {
    const { accountId, category, customerType } = account;

    if (category === 'Individual') {
        return printf(__('个人账户(%s)'), accountId);
    }

    if (category === 'IRA') {
        switch (customerType) {
            case AccountCustomerTypeEnum.IRA_TRADITIONAL:
                return printf(__('Traditional IRA (%s)'), accountId);
            case AccountCustomerTypeEnum.IRA_ROTH:
                return printf(__('Roth IRA (%s)'), accountId);
            case AccountCustomerTypeEnum.IRA_ROLLOVER:
                return printf(__('Rollover IRA (%s)'), accountId);
            default:
                return '';
        }
    }

    return '';
};
